"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebVitalsManager = void 0;
const web_vitals_1 = require("web-vitals");
const client_core_1 = require("@statsig/client-core");
const AutoCaptureEvent_1 = require("./AutoCaptureEvent");
const commonUtils_1 = require("./utils/commonUtils");
const VALID_METRIC_NAMES = ['CLS', 'FCP', 'LCP', 'TTFB'];
class WebVitalsManager {
    constructor(_enqueueFn) {
        this._enqueueFn = _enqueueFn;
        this._isInitialized = false;
    }
    startTracking() {
        var _a, _b;
        if (this._isInitialized) {
            return;
        }
        const protocol = (_b = (_a = (0, client_core_1._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.protocol;
        if (protocol !== 'https:' && protocol !== 'http:') {
            return;
        }
        (0, web_vitals_1.onCLS)((metric) => this._handleMetric(metric));
        (0, web_vitals_1.onFCP)((metric) => this._handleMetric(metric));
        (0, web_vitals_1.onLCP)((metric) => this._handleMetric(metric));
        (0, web_vitals_1.onTTFB)((metric) => this._handleMetric(metric));
        this._isInitialized = true;
    }
    _handleMetric(metric) {
        if (metric === undefined || (metric === null || metric === void 0 ? void 0 : metric.name) === undefined) {
            return;
        }
        const currentUrl = (0, commonUtils_1._getSafeUrlString)();
        if (currentUrl === '') {
            // If the URL is not valid, we don't want to track the metric
            return;
        }
        if (!VALID_METRIC_NAMES.includes(metric.name)) {
            return;
        }
        this._enqueueWebVitalsAutoCaptureEvent(metric, currentUrl);
    }
    _enqueueWebVitalsAutoCaptureEvent(metric, url) {
        if (url === '') {
            return;
        }
        this._enqueueFn(AutoCaptureEvent_1.AutoCaptureEventName.WEB_VITALS, url, {
            name: metric.name,
            value: metric.value,
            delta: metric.delta,
            id: metric.id,
        });
    }
}
exports.WebVitalsManager = WebVitalsManager;
